/* eslint-disable */

import Work1 from  "../../assets/work1.jpg";
import Work2 from  "../../assets/work2.jpg";
import Work3 from  "../../assets/work3.jpg";
import Work4 from  "../../assets/work4.jpg";
import Work5 from  "../../assets/work5.jpg";


export const projectData = [
    {
        id: 1,
        image: Work1,
        title: 'Cocktail Website',
        description: '',
        category: 'Reactjs',
        Llink:"https://tonnytech.github.io/Cocktails/",
        Slink:"https://github.com/tonnytech/Cocktails",
    },
    {
        id: 2,
        image: Work2,
        title: 'Calculator website',
        category: 'Reactjs',
        Llink:"https://tonnytech.github.io/Math-magician/",
        Slink:"https://github.com/tonnytech/Math-magician"
    },
    {
        id: 3,
        image: Work3,
        title: 'Music concert landing page',
        category: 'WebDesign',
        Llink:"https://tonnytech.github.io/Music-concert-landing-page/src/",
        Slink:"https://github.com/tonnytech/Music-concert-landing-page",
    },
    {
        id: 4,
        image: Work4,
        title: 'Clip-Board website',
        category: 'WebDesign',
        Llink:"https://tonnytech.github.io/ClipBoard-Website/",
        Slink:"https://github.com/tonnytech/ClipBoard-Website"
    },
    {
        id: 5,
        image: Work5,
        title: 'MERN stack',
        category: 'MERN',
        Llink:"",
        Slink:"",
    },
]

export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'WebDesign',
    },
    {
        name: 'Reactjs',
    },
    {
        name: 'MERN',
    },

]